package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px

val ReferenceFormContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("display", "flex")
                property("flex-direction", "column")
                property("gap", "15px")
            }
    }

    Breakpoint.MD {
        Modifier
            .styleModifier {
                property("gap", "25px")
            }
    }
}

val ReferenceFullWidthFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("flex", "1 1 100%")
            }
    }
}

val ReferenceFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
            .styleModifier {
                property("display", "flex")
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("flex-wrap", "nowrap")
                property("align-items", "stretch")
            }
    }

    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .gap(25.px)
            .styleModifier {
                property("display", "flex")
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("align-items", "flex-start")
            }
    }
}

val ReferenceHalfWidthFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("flex", "1 1 100%")
            }
    }

    Breakpoint.MD {
        Modifier
            .styleModifier {
                property("width", "0")
                property("max-width", "100%")
                property("min-width", "0")
                property("flex", "1 1 0")
                property("box-sizing", "border-box")
            }
    }
}